import React from 'react';

import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import cls from './ModalBodyAddManagerInfo.module.css';
import { useModalBodyAddManagerInfo } from './useModalBodyAddManagerInfo';
import { Input } from '../../../../../components/newUI/Input/Input';
import { ManagerInformation } from '../../../types/dashboardInformation';
import { ErrorsMessage } from '../useModalAddManagerInfo';

interface ModalBodyAddManagerInfoProps {
    form: ManagerInformation;
    classes?: string;
    onForm: (name: string, value: string) => void;
    errors: ErrorsMessage;
    isEdit?: boolean;
}

export const ModalBodyAddManagerInfo = ({
    classes,
    form,
    onForm,
    errors,
}: ModalBodyAddManagerInfoProps) => {
    const { t } = useTranslation();
    return (
        <form className={classNames(cls.ModalBodyAddManagerInfo, [classes])}>
            <Input
                inputName="full_name"
                label={t('ModalBodyAddManagerInfo.return.inputName.label')}
                placeholder={t('ModalBodyAddManagerInfo.return.inputName.placeholder')}
                onChange={onForm}
                value={form.full_name}
                errorMessage=""
                error={errors.name}
                classes={cls.inputRow}
                maxLength={128}
            />
            <Input
                inputName="position"
                label={t('ModalBodyAddManagerInfo.return.inputPosition.label')}
                placeholder={t('ModalBodyAddManagerInfo.return.inputPosition.placeholder')}
                onChange={onForm}
                value={form.position}
                errorMessage=""
                classes={cls.inputRow}
                maxLength={255}
            />
            <div className={cls.container}>
                <Input
                    inputName="email"
                    label={t('ModalBodyAddManagerInfo.return.inputEmail.label')}
                    placeholder={t('ModalBodyAddManagerInfo.return.inputEmail.placeholder')}
                    onChange={onForm}
                    value={form.email}
                    errorMessage=""
                    error={errors.email}
                    classes={cls.inputGrow}
                    maxLength={64}
                />
                <Input
                    inputName="phone"
                    label={t('ModalBodyAddManagerInfo.return.inputPhone.label')}
                    placeholder={t('ModalBodyAddManagerInfo.return.inputPhone.placeholder')}
                    onChange={onForm}
                    value={form.phone}
                    errorMessage=""
                    classes={cls.inputGrow}
                    maxLength={25}
                />
            </div>
        </form>
    );
};
